import React, { Component } from 'react'
import { connect } from 'react-redux'

import { getForsiList, updateForsiList } from '../../actions/chains'

import Header from '../../shared/components/Header'

import { renderFullDate } from '../../utils/time'
import { translation } from '../../utils/helpers'
import { ElementIcons } from '../../shared/elements/icons'

import TableContainer from '../../shared/elements/tableContainer'
import TableRow from '../../shared/elements/tableRow'
import Icon from '../../shared/elements/icon'
import Inline from '../../shared/elements/inline'

import './index.scss'

class ForsiList extends Component {

  constructor (props) {
    super(props)
    this.state = {
      list: []
    }
    this.renderItem = this.renderItem.bind(this)
  }

  componentDidMount () {
    this.getForsiList()
  }

  getForsiList () {
    this.props.getForsiList().then((res) => {
      this.setState({
        list: res.data
      })
    }, () => {
      window.toastr.error(translation('2225'), translation('216'))
      this.props.router.push('/')
    })
  }

  renderItem (item, key) {
    return (
      <TableRow>
        <div>{item.ShopName}</div>
        <div>{item.Mail}</div>
        <div>{item.Phone}</div>
        <div>{renderFullDate(item.LastUpdated)}</div>
        <div>{item.ForsiBodyShopId}</div>
        <div>{this.renderActive(item)}</div>
      </TableRow>
    )
  }

  renderActive (item) {
    const changeActive = () => {
      this.props.updateForsiList(item.ShopId, !item.Active).then((res) => {
        this.setState({
          list: res.data
        })
        // window.toastr.success(translation('2226'), translation('13424'))
      }, () => {
        window.toastr.error(translation('2227'), translation('216'))
      })
    }
    return (
      <span onClick={changeActive}>
        <Inline>
          {item.Active ? <Icon icon={ElementIcons.Inspection_Check} /> : <Icon icon={ElementIcons.Inspection_Cancel} />} {item.Active ? translation('295') : translation('296')}
        </Inline>
      </span>
    )
  }

  render () {
    return (
      <div>
        <Header router={this.props.router} title={translation('2228')} icon={'menu/Forsi-white30x30px.png'} />
        <TableContainer>
          <TableRow header>
            <div>{translation('30')}</div>
            <div>{translation('151')}</div>
            <div>{translation('38')}</div>
            <div>{translation('560')}</div>
            <div>{translation('14803')}</div>
            <div>{translation('13438')}</div>
          </TableRow>
          {this.state.list.map(this.renderItem)}
        </TableContainer>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getForsiList,
  updateForsiList
})(ForsiList)



// WEBPACK FOOTER //
// ./src/app/pages/ForsiList/index.js